// import React from "react";
import { Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ReviewBeanth = ({ product }) => {
  const navigate = useNavigate();
  if (!product) return null;

  const ratingPercentages = [
    { star: 5, percent: product.rate_5_percent },
    { star: 4, percent: product.rate_4_percent },
    { star: 3, percent: product.rate_3_percent },
    { star: 2, percent: product.rate_2_percent },
    { star: 1, percent: product.rate_1_percent },
  ];

  const getReviewStars = (review) => {
    if (review?.rate1 === 1) return 1;
    if (review?.rate2 === 1) return 2;
    if (review?.rate3 === 1) return 3;
    if (review?.rate4 === 1) return 4;
    if (review?.rate5 === 1) return 5;
    return 0;
  };

  return (
    <div className="mt-10 md:px-10 py-8 flex flex-col md:flex-row gap-10">
      {/* LEFT SIDE: Rating Breakdown */}
      <div className="flex-1 bg-white rounded-2xl">
        <div className="border rounded-xl p-6">
          {/* Overall Rating */}
          <div className="flex items-center gap-2 mb-6">
            <span className="text-2xl font-semibold">
              {Math.round(product.rating || 0)}
            </span>
            <Star size={20} className="text-yellow-400 fill-yellow-400" />
            <span className="text-gray-500 text-sm">Reviews from people</span>
          </div>

          {/* Progress Bars */}
          <div className="space-y-4">
            {ratingPercentages.map((r) => (
              <div key={r.star} className="flex items-center gap-3">
                <span className="w-12 text-sm text-gray-600">
                  {r.star} Star
                </span>

                <div className="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-yellow-400 rounded-full transition-all duration-500"
                    style={{ width: `${r.percent}%` }}
                  />
                </div>

                <span className="text-sm text-gray-500 w-10 text-right">
                  {r.percent}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: Reviews Preview */}
      <div className="flex-1.5 md:flex-[2]">
        <h2 className="text-lg font-semibold mb-6">Reviews</h2>

        <div className="space-y-6">
          {product.product_content_reviews?.slice(0, 5).map((review) => {
            const stars = getReviewStars(review);

            return (
              <div key={review.id} className="pb-6 border-b last:border-none">
                {/* Stars */}
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Star
                      key={index}
                      size={18}
                      className={
                        index < stars
                          ? "text-yellow-400 fill-yellow-400"
                          : "text-gray-300"
                      }
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 text-sm leading-relaxed mb-3">
                  {review.text}
                </p>

                {/* Review Images */}
                {review.img?.length > 0 && (
                  <div className="flex gap-3 flex-wrap">
                    {review.img.map((image) => (
                      <img
                        key={image.id}
                        src={image.img}
                        alt="review"
                        className="w-20 h-20 object-cover rounded-lg border hover:scale-105 transition"
                      />
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* See More */}
        <button
          onClick={() =>
            navigate(`/DedicatedReview/${product.id}`, {
              state: { product },
            })
          }
          className="mt-6 text-orange-500 font-medium text-sm hover:underline"
        >
          See More Reviews
        </button>
      </div>
    </div>
  );
};

export default ReviewBeanth;
